export default __webpack_public_path__ + "static/media/Padas.c732a7ce.jpg";